import { useMutation, useQueryClient } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';

const useDeletePost = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      promptId,
      postIds,
    }: {
      promptId: number;
      postIds: number[];
    }) => {
      return Promise.all(
        postIds.map((postId) => PromptService.deletePost(promptId, postId))
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['posts'] });
    },
  });
};

export default useDeletePost;
